<template>
  <main>
    <background-wrapper src="policy-footer" ext="png">
      <ContentWithImage class="pb-4 pt-5" src="request-demo" image-order="0" image-order-sm="1" margin="0">
        <text-container>
          <h2 class="h1 center" v-html="$t(`RequestDemo.title`)"/>
          <!-- Start of Meetings Embed Script -->
          <div class="meetings-iframe-container" data-src="https://emails.hrdownloads.com/meetings/mtrainor/request-a-demo?embed=true"></div>
          <!-- End of Meetings Embed Script -->
          <!--<p class="disclaimer" v-html="$t(`RequestDemo.disclaimer`)"/>-->
        </text-container>
      </ContentWithImage>
    </background-wrapper>
  </main>
</template>
<script>
import ContentWithImage from '@/components/ui/ContentWithImage.vue'

export default {
  name: 'RequestDemo',
  components: { ContentWithImage },
  mounted () {
    const script = document.createElement('script')
    script.src = 'https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js'
    document.body.appendChild(script)
  }
}
</script>

<style lang="sass" scoped>
.center
  text-align: center
  width: 100%
.disclaimer
  line-height: 16px
  font-size: 12px
.form
  width: 100%
  margin: 0 0 30px 0
  padding: 10px 30px
  background-color: #fff
  border: 1px solid #EEF1F7
  border-radius: 5px
.meetings-iframe-container
  margin: 0 auto
</style>



// WEBPACK FOOTER //
// src/components/requestDemo/RequestDemo.vue